import React, {useContext, useEffect, useState} from "react";
import {FaSearch} from "react-icons/fa";
import {Link, useNavigate} from 'react-router-dom';
import axios from "axios";
import {LoginContext} from "../../../context/LoginContext";

const SearchById = () => {
    const [profileId, setProfileId] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { isLoggedIn } = useContext(LoginContext);


    useEffect(() => {
        if (!isLoggedIn) {
            navigate("/login");
        }

    },[])

    const handleSearch = async (e) => {
      e.preventDefault();

        if (!profileId.trim() || profileId.length < 6) {
            setError("Please enter Valid Profile Id.");
            return;
        }

        if(profileId!="" && profileId!=undefined){
            navigate(`/search?id=${profileId}`);
        }


    };

    return (
        <div className="id-search-form my-5 px-3 ">
            <h2>
                Search <span className="highlight">By Profile ID</span>
            </h2>
            <form onSubmit={handleSearch} >


                <div className="form-group">
                    <label>Search By Profile ID:</label>
                    <input
                        type="text"
                        className="search-inputt"
                        placeholder="e.g. HS1234"
                        value={profileId}
                        onChange={(e) => {
                            setProfileId(e.target.value);
                            setError("");
                            console.log(e.target.value);
                        }}
                    />
                    {error && <p style={{color: "red", fontSize: "13px"}}>{error}</p>}
                </div>

                <button type="button" className="search-btn-full mt-3" onClick={handleSearch}>
                    <FaSearch/> Search
                </button>
            </form>
            {/*<div className="divider">Or</div>*/}

            {/*<button type="button" className="search-id-btnn">*/}
            {/*  <Link*/}
            {/*    to="/custom-search"*/}
            {/*    style={{ textDecoration: "none", color: "inherit" }}*/}
            {/*  >*/}
            {/*    Click Here For Custom Search*/}
            {/*  </Link>*/}
            {/*</button>*/}

            <style>
                {`
        .id-search-form {
          max-width: 400px;
          margin: auto;
          padding: 24px;
          background: #fff;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
          font-family: sans-serif;

          @media (max-width:500px){
          margin:0 15px;
          }

        }

        .id-search-form h2 {
          margin-bottom: 20px;
          font-size: 20px;
          text-align: center;
        }

        .highlight {
          color: #e53d5c;
        }

        .form-group {
          margin-bottom: 16px;
        }

        .form-group label {
          display: block;
          margin-bottom: 6px;
          font-weight: bold;
        }

        .search-inputt {
          width: 100%;
          padding: 10px;
          font-size: 14px;
          border: 1px solid #ccc;
          border-radius: 6px;
          outline: none;
        }

        .search-btn-full,
        .search-id-btnn {
          width: 100%;
          padding: 10px;
          background-color: #e53d5c;
          color: white;
          font-size: 14px;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }

        .divider {
          text-align: center;
          margin: 12px 0;
          font-size: 14px;
          color: #777;
        }
      `}
            </style>

            
        </div>
    );
};

export default SearchById;
